import { render, staticRenderFns } from "./Descricao-checkout.vue?vue&type=template&id=36bf2cd6&scoped=true&"
import script from "./Descricao-checkout.vue?vue&type=script&lang=js&"
export * from "./Descricao-checkout.vue?vue&type=script&lang=js&"
import style0 from "./Descricao-checkout.vue?vue&type=style&index=0&id=36bf2cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf2cd6",
  null
  
)

export default component.exports